import React from 'react'
import { useAtomValue } from 'jotai/react'
import { useTranslation } from 'react-i18next'
import { Box, Button, DataListItem, Icon } from '@node-space/ui-components'
import { currentCustomerAtom } from 'pages/Customers/atoms/customersAtoms'
import { Card } from 'services/CardService'
import { formatExpiryDate, getCardholderName, isFreezeDisabled } from './utils/cardUtils'

interface CardDetailsTabProps {
  card: Card
  onFreeze?: () => void
}

export const CardDetailsTab = ({ card, onFreeze }: CardDetailsTabProps) => {
  const { t } = useTranslation()
  const customer = useAtomValue(currentCustomerAtom)

  const cardholderName = getCardholderName(customer)
  const expiryDate = formatExpiryDate(card.expiresAt)
  const isFrozen = card.status === 'FROZEN'
  const freezeButtonLabel = isFrozen
    ? t('customers.cardDetails.unfreezeCard')
    : t('customers.cardDetails.freezeCard')

  return (
    <Box flexCol gapY={16} width="full" paddingT={16}>
      <Box flexCol width="full">
        <DataListItem
          id="cardholder-name"
          title={t('customers.cardDetailsSidePanel.cardholderName')}
          body={cardholderName}
          {...(cardholderName && { copyText: cardholderName })}
        />
        <DataListItem
          id="card-number"
          title={t('customers.cardDetailsSidePanel.cardNumber')}
          body={`****${card.last4Digits}`}
        />
        <DataListItem
          id="expiry-date"
          title={t('customers.cardDetailsSidePanel.expiryDate')}
          body={expiryDate}
          {...(expiryDate && { copyText: expiryDate })}
        />
      </Box>

      <Box paddingT={8}>
        <Button
          full
          iconPosition="left"
          label={freezeButtonLabel}
          iconElement={<Icon name="Snowflake" />}
          variant="secondary"
          onClick={onFreeze}
          disabled={isFreezeDisabled(card.status)}
        >
          {freezeButtonLabel}
        </Button>
      </Box>
    </Box>
  )
}
